var map = {
	"./AdvancedExcel.webp": 5080,
	"./Blockchain.png": 983,
	"./Graphic-Design.png": 4846,
	"./UI-UX.jpeg": 2136,
	"./account2.jpeg": 3226,
	"./accounting.png": 1820,
	"./architecture.webp": 779,
	"./cloud-computing.jpeg": 3302,
	"./computer-basics.webp": 7552,
	"./cyber-security-illustration-free-vector.jpeg": 9662,
	"./dat- science.jpeg": 7917,
	"./devops.webp": 3429,
	"./digital-marketing.jpeg": 4224,
	"./embedded-system.jpg": 567,
	"./engineer.avif": 5282,
	"./excel.png": 7696,
	"./matlab.jpg": 6941,
	"./product-manager.webp": 969,
	"./robotics-and-automation.png": 4673,
	"./software-Engineering.jpeg": 2352,
	"./video-animation.jpeg": 9529,
	"./web-design.webp": 3434,
	"./webdev.webp": 2817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;